import * as actions from './actions';
import * as getters from './getters';
import BlockTimesState from './state';

export { actions, getters };
export default BlockTimesState;
